import { db } from './firebase';

// User API

export const doCreateUser = (id, firstName, lastName, email) =>
  db.ref(`users/${id}`).set({
    firstName,
    lastName,
    email,
  });

export const onceUserData = () =>
  db.app.database().ref('userData');

// export const getUserData = () =>
// userDatabaseRef:firebase.database.Reference = db.app.database().ref('userData');

export const onceGetUsers = () =>
  db.ref('users').once('value');

// Other db APIs ...



// WEBPACK FOOTER //
// ./src/firebase/db.tsx